const letterSpacing = {
  'letter-spacing-wide': '0.1rem',
};

module.exports = letterSpacing;
